
function detectTouch() {
  return 'ontouchstart' in window       
    || navigator.maxTouchPoints;
};

const isTouchDevice = detectTouch();

export default isTouchDevice;
